import { fork } from 'redux-saga/effects';

import { actions, selectors } from 'domain/auction';
import { listNavigator } from 'sagas/common';
import { filters } from 'filters/auction';

export default function* navigator() {
  yield fork(listNavigator, { modelName: 'Auction', actions, selectors, filters } );
}
